import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //staleTime: 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// if (import.meta.env.MODE === 'development') {
//   window.queryClient = queryClient;
// }
